import { AttributeAPI } from "@griffingroupglobal/eslib-api";

const addAttributesHandler = async (props) => {
  const response = await AttributeAPI.postWOP("$bulkcreate", {
    attributes: props.args.createdItems,
  });
  return response?.data;
};

export default addAttributesHandler;
